export const CountryRegex = [
    {
      id: 'VN',
      country: 'VIET NAM',
      reg: /^\d{5}$/
    },
    {
      id: 'FX',
      country: 'FRANCE, METROPOLITAN',
      reg: null
    },
    {
      id: 'AU',
      country: 'AUSTRALIA',
      reg: /^\d{4}$/
    },
    {
      id: 'AT',
      country: 'AUSTRIA',
      reg: /^\d{4}$/
    },
    {
      id: 'BE',
      country: 'BELGIUM',
      reg: /^\d{4}$/
    },
    {
      id: 'CN',
      country: 'CHINA',
      reg: /^\d{6}$/
    },
    {
      id: 'CX',
      country: 'CHRISTMAS ISLAND',
      reg: /^\d{4}$/
    },
    {
      id: 'CC',
      country: 'COCOS (KEELING) ISLANDS',
      reg: /^\d{4}$/
    },
    {
      id: 'EC',
      country: 'ECUADOR',
      reg: /^\d{6}$/
    },
    {
      id: 'FI',
      country: 'FINLAND',
      reg: /^\d{5}$/
    },
    {
      id: 'FR',
      country: 'FRANCE',
      reg: /^\d{5}$/
    },
    {
      id: 'GF',
      country: 'FRENCH GUIANA',
      reg: /^973\d{2}$/
    },
    {
      id: 'GR',
      country: 'GREECE',
      reg: /^\d{3}\s{0,1}\d{2}$/
    },
    {
      id: 'GP',
      country: 'GUADELOUPE',
      reg: /^971\d{2}$/
    },
    {
      id: 'GU',
      country: 'GUAM',
      reg: /^\d{5}$/
    },
    {
      id: 'HK',
      country: 'HONG KONG',
      reg: null
    },
    {
      id: 'ID',
      country: 'INDONESIA',
      reg: /^\d{5}$/
    },
    {
      id: 'ES',
      country: 'SPAIN',
      reg: /^\d{5}$/
    },
    {
      id: 'AQ',
      country: 'ANTARCTICA',
      reg: null
    },
    {
      id: 'BV',
      country: 'BOUVET ISLAND',
      reg: null
    },
    {
      id: 'CS',
      country: 'SERBIA AND MONTENEGRO (FORMERLY YUGOSLAVIA)',
      reg: null
    },
    {
      id: 'BD',
      country: 'BANGLADESH',
      reg: /^\d{4}$/
    },
    {
      id: 'BR',
      country: 'BRAZIL',
      reg: '^\d{5}-\d{3}$'
    },
    {
      id: 'CM',
      country: 'CAMEROON',
      reg: null
    },
    {
      id: 'HU',
      country: 'HUNGARY',
      reg: /^\d{4}$/
    },
    {
      id: 'IS',
      country: 'ICELAND',
      reg: /^\d{3}$/
    },
    {
      id: 'CH',
      country: 'SWITZERLAND',
      reg: /^\d{4}$/
    },
    {
      id: 'EG',
      country: 'EGYPT',
      reg: /^\d{4}$/
    },
    {
      id: 'AO',
      country: 'ANGOLA',
      reg: null
    },
    {
      id: 'EH',
      country: 'WESTERN SAHARA',
      reg: null
    },
    {
      id: 'SE',
      country: 'SWEDEN',
      reg: /^\d{3}\s\d{2}$/
    },
    {
      id: 'SE',
      country: 'EL SALVADOR',
      reg: /^1101$/
    },
    {
      id: 'IT',
      country: 'ITALY',
      reg: /^\d{5}$/
    },
    {
      id: 'KI',
      country: 'KIRIBATI',
      reg: null
    },
    {
      id: 'LU',
      country: 'LUXEMBOURG',
      reg: /^\d{4}$/
    },
    {
      id: 'MY',
      country: 'MALAYSIA',
      reg: /^\d{5}$/
    },
    {
      id: 'MH',
      country: 'MARSHALL ISLANDS',
      reg: /^\d{5}$/
    },
    {
      id: 'MQ',
      country: 'MARTINIQUE',
      reg: /^972\d{2}$/
    },
    {
      id: 'NR',
      country: 'NAURU',
      reg: null
    },
    {
      id: 'NL',
      country: 'NETHERLANDS',
      reg: /^\d{4}\s{0,1}[A-Za-z]{2}$/
    },
    {
      id: 'MP',
      country: 'NORTHERN MARIANA ISLANDS',
      reg: /^\d{5}$/
    },
    {
      id: 'PW',
      country: 'PALAU',
      reg: /^\d{5}$/
    },
    {
      id: 'PR',
      country: 'PUERTO RICO',
      reg: /^\d{5}$/
    },
    {
      id: 'PM',
      country: 'ST PIERRE AND MIQUELON',
      reg: /^97500$/
    },
    {
      id: 'SM',
      country: 'SAN MARINO',
      reg: /^4789\d$/
    },
    {
      id: 'SG',
      country: 'SINGAPORE',
      reg: /^\d{6}$/
    },
    {
      id: 'SI',
      country: 'SLOVENIA',
      reg: /^([Ss][Ii][- ]{0,1}){0,1}\d{4}$/
    },
    {
      id: 'LA',
      country: 'LAO PEOPLE\'S DEMOCRATIC REPUBLIC (FORMERLY LAOS)',
      reg: /^\d{5}$/
    },
    {
      id: 'NZ',
      country: 'NEW ZEALAND',
      reg: /^\d{4}$/
    },
    {
      id: 'NG',
      country: 'NIGERIA',
      reg: /^\d{6}$/
    },
    {
      id: 'PH',
      country: 'PHILIPPINES',
      reg: /^\d{4}$/
    },
    {
      id: 'PL',
      country: 'POLAND',
      reg: /^\d{2}[- ]{0,1}\d{3}$/
    },
    {
      id: 'RU',
      country: 'RUSSIAN FEDERATION',
      reg: /^\d{6}$/
    },
    {
      id: 'LK',
      country: 'SRI LANKA',
      reg: /^\d{5}$/
    },
    {
      id: 'MN',
      country: 'MONGOLIA',
      reg: /^\d{5}$/
    },
    {
      id: 'MN',
      country: 'MONGOLIA',
      reg: /^\d{5}$/
    },
    {
      id: 'MG',
      country: 'MADAGASCAR',
      reg: /^\d{3}$/
    },
    {
      id: 'MO',
      country: 'MACAO (ALSO SPELLED MACAU)',
      reg: null
    },
    {
      id: 'KW',
      country: 'KUWAIT',
      reg: /^\d{5}$/
    },
    {
      id: 'AD',
      country: 'ANDORRA',
      reg: /^[Aa][Dd]\d{3}$/
    },
    {
      id: 'AE',
      country: 'UNITED ARAB EMIRATES',
      reg: null
    },
    {
      id: 'DZ',
      country: 'ALGERIA',
      reg: /^\d{5}$/
    },
    {
      id: 'TH',
      country: 'THAILAND',
      reg: /^\d{5}$/
    },
    {
      id: 'UM',
      country: 'UNITED STATES MINOR OUTLYING ISLANDS',
      reg: null
    },
    {
      id: 'FM',
      country: 'MICRONESIA, FEDERATED STATES OF',
      reg: /^\d{5}$/
    },
    {
      id: 'TV',
      country: 'TUVALU',
      reg: null
    },
    {
      id: 'VI',
      country: 'VIRGIN ISLANDS (US)',
      reg: /^\d{5}$/
    },
    {
      id: 'VA',
      country: 'HOLY SEE (VATICAN CITY STATE)',
      reg: /^120$/
    },
    {
      id: 'VG',
      country: 'VIRGIN ISLANDS (BRITISH)',
      reg: /^[Vv][Gg]\d{4}$/
    },
    {
      id: 'TF',
      country: 'FRENCH SOUTHERN AND ANTARCTIC TERRITORIES',
      reg: null
    },
    {
      id: 'DE',
      country: 'GERMANY (WEST AND EAST)',
      reg: /^\d{5}$/
    },
    {
      id: 'HM',
      country: 'HEARD AND MCDONALD ISLANDS',
      reg: /^\d{4}$/
    },
    {
      id: 'IE',
      country: 'IRELAND',
      reg: /^\d{4}$/
    },
    {
      id: 'MT',
      country: 'MALTA',
      reg: /^[A-Za-z]{3}\s{0,1}\d{4}$/
    },
    {
      id: 'YT',
      country: 'MAYOTTE',
      reg: /^976\d{2}$/
    },
    {
      id: 'MC',
      country: 'MONACO',
      reg: /^980\d{2}$/
    },
    {
      id: 'MV',
      country: 'MALDIVES',
      reg: /^\d{4,5}$/
    },
    {
      id: 'NP',
      country: 'NEPAL',
      reg: /^\d{5}$/
    },
    {
      id: 'PK',
      country: 'PAKISTAN',
      reg: /^\d{5}$/
    },
    {
      id: 'MX',
      country: 'MEXICO',
      reg: /^\d{5}$/
    },
    {
      id: 'CL',
      country: 'CHILE',
      reg: '^\d{7}\s\(\d{3}-\d{4}\)$'
    },
    {
      id: 'UY',
      country: 'URUGUAY',
      reg: /^\d{5}$/
    },
    {
      id: 'UA',
      country: 'UKRAINE',
      reg: /^\d{5}$/
    },
    {
      id: 'XO',
      country: 'WEST AFRICA',
      reg: null
    },
    {
      id: 'KH',
      country: 'CAMBODIA (FORMERLY KAMPUCHEA)',
      reg: /^\d{5}$/
    },
    {
      id: 'AL',
      country: 'ALBANIA',
      reg: /^\d{4}$/
    },
    {
      id: 'TJ',
      country: 'TAJIKISTAN',
      reg: /^\d{6}$/
    },
    {
      id: 'PT',
      country: 'PORTUGAL',
      reg: /^\d{4}[- ]{0,1}\d{3}$/
    },
    {
      id: 'TC',
      country: 'TURKS AND CAICOS ISLANDS',
      reg: /^[Tt][Kk][Cc][Aa]\s{0,1}[1][Zz]{2}$/
    },
    {
      id: 'US',
      country: 'UNITED STATES OF AMERICA',
      reg: /^\b\d{5}\b(?:[- ]{1}\d{4})?$/
    },
    {
      id: 'AS',
      country: 'AMERICAN SAMOA',
      reg: /^\d{5}(-{1}\d{4,6})$/
    },
    {
      id: 'TW',
      country: 'TAIWAN, PROVINCE OF CHINA',
      reg: /^\d{3}$/
    },
    {
      id: 'KR',
      country: 'KOREA, REPUBLIC OF (SOUTH KOREA)',
      reg: /^\d{5}$/
    },
    {
      id: 'GB',
      country: 'UNITED KINGDOM',
      reg: /^[A-Z]{1,2}[0-9R][0-9A-Z]? [0-9][ABD-HJLNP-UW-Z]{2}$/
    },
    {
      id: 'AN',
      country: 'NETHERLANDS ANTILLES',
      reg: null
    },
    {
      id: 'JM',
      country: 'JAMAICA',
      reg: /^\d{2}$/
    },
    {
      id: 'CA',
      country: 'CANADA',
      reg: /^(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\d(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\s{0,1}\d(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\d$/
    },
    {
      id: 'TR',
      country: 'TURKEY',
      reg: /^\d{5}$/
    },
    {
      id: 'ZA',
      country: 'SOUTH AFRICA',
      reg: /^\d{4}$/
    },
    {
      id: 'AF',
      country: 'AFGHANISTAN',
      reg: /^\d{4}$/
    },
    {
      id: 'DK',
      country: 'DENMARK',
      reg: /^\d{4}$/
    },
    {
      id: 'HC',
      country: 'HO CHI MINH',
      reg: null
    },
    {
      id: 'AL',
      country: 'ANGUILLA',
      reg: /^[Aa][I][-][2][6][4][0]$/
    },
    {
      id: 'AG',
      country: 'ANTIGUA AND BARBUDA',
      reg: null
    },
    {
      id: 'AM',
      country: 'ARMENIA',
      reg: /^\d{4}$/
    },
    {
      id: 'AW',
      country: 'ARUBA',
      reg: null
    },
    {
      id: 'BH',
      country: 'BAHRAIN',
      reg: /^\d{3,4}$/
    },
    {
      id: 'BY',
      country: 'BELARUS (FORMERLY KNOWN AS BYELORUSSIA)',
      reg: /^\d{6}$/
    },
    {
      id: 'BZ',
      country: 'BELIZE',
      reg: null
    },
    {
      id: 'BJ',
      country: 'BENIN',
      reg: null
    },
    {
      id: 'BT',
      country: 'BHUTAN',
      reg: /^\d{5}$/
    },
    {
      id: 'BO',
      country: 'BOLIVIA',
      reg: /^\d{4}$/
    },
    {
      id: 'BW',
      country: 'BOTSWANA',
      reg: null
    },
    {
      id: 'BN',
      country: 'BRUNEI DARUSSALAM',
      reg: /^[A-Za-z]{2}\d{4}$/
    },
    {
      id: 'BG',
      country: 'BULGARIA',
      reg: /^\d{4}$/
    },
    {
      id: 'BF',
      country: 'BURKINA FASO',
      reg: null
    },
    {
      id: 'BI',
      country: 'BURUNDI',
      reg: null
    },
    {
      id: 'CV',
      country: 'CAPE VERDE',
      reg: /^\d{4}$/
    },
    {
      id: 'CF',
      country: 'CENTRAL AFRICAN REPUBLIC',
      reg: null
    },
    {
      id: 'CO',
      country: 'COLOMBIA',
      reg: /^\d{6}$/
    },
    {
      id: 'CD',
      country: 'CONGO, DEMOCRATIC REPUBLIC OF THE (FORMERLY ZAIRE)',
      reg: /^[Cc][Dd]$/
    },
    {
      id: 'CK',
      country: 'COOK ISLANDS',
      reg: null
    },
    {
      id: 'CI',
      country: 'IVORY COAST',
      reg: null
    },
    {
      id: 'HR',
      country: 'CROATIA (LOCAL NAME: HRVATSKA)',
      reg: /^\d{5}$/
    },
    {
      id: 'HR',
      country: 'CUBA',
      reg: /^\d{5}$/
    },
    {
      id: 'DJ',
      country: 'DJIBOUTI',
      reg: null
    },
    {
      id: 'DM',
      country: 'DOMINICA',
      reg: null
    },
    {
      id: 'GQ',
      country: 'EQUATORIAL GUINEA',
      reg: null
    },
    {
      id: 'ER',
      country: 'ERITREA',
      reg: null
    },
    {
      id: 'EE',
      country: 'ESTONIA',
      reg: /^\d{5}$/
    },
    {
      id: 'FO',
      country: 'FAROE ISLANDS',
      reg: /^\d{3}$/
    },
    {
      id: 'FJ',
      country: 'FIJI ISLANDS',
      reg: null
    },
    {
      id: 'GA',
      country: 'GABON',
      reg: /^\d{2}\s[a-zA-Z-_ ]\s\d{2}$/
    },
    {
      id: 'GE',
      country: 'GEORGIA',
      reg: /^\d{4}$/
    },
    {
      id: 'GH',
      country: 'GHANA',
      reg: null
    },
    {
      id: 'GI',
      country: 'GIBRALTAR',
      reg: /^[Gg][Xx][1]{2}\s{0,1}[1][Aa]{2}$/
    },
    {
      id: 'GN',
      country: 'GUINEA',
      reg: null
    },
    {
      id: 'GW',
      country: 'GUINEA-BISSAU',
      reg: /^\d{4}$/
    },
    {
      id: 'GY',
      country: 'GUYANA',
      reg: null
    },
    {
      id: 'HT',
      country: 'HAITI',
      reg: /^\d{4}$/
    },
    {
      id: 'HN',
      country: 'HONDURAS',
      reg: /^\d{5}$/
    },
    {
      id: 'IR',
      country: 'IRAN, ISLAMIC REPUBLIC OF',
      reg: /^\d{5}-\d{5}$/
    },
    {
      id: 'IQ',
      country: 'IRAQ',
      reg: /^\d{5}$/
    },
    {
      id: 'IL',
      country: 'ISRAEL',
      reg: /^\d{7}$/
    },
    {
      id: 'GS',
      country: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
      reg: /^[Ss][Ii][Qq]{2}\s{0,1}[1][Zz]{2}$/
    },
    {
      id: 'PO',
      country: 'PORTLAND, OREGON',
      reg: null
    },
    {
      id: 'PN',
      country: 'PITCAIRN ISLAND',
      reg: /^[Pp][Cc][Rr][Nn]\s{0,1}[1][Zz]{2}$/
    },
    {
      id: 'TN',
      country: 'TUNISIA',
      reg: /^\d{4}$/
    },
    {
      id: 'UG',
      country: 'UGANDA',
      reg: /^\d{4}$/
    },
    {
      id: 'VE',
      country: 'VENEZUELA',
      reg: /^\d{4}(\s[a-zA-Z]{1})?$/
    },
    {
      id: 'SY',
      country: 'SYRIAN ARAB REPUBLIC',
      reg: null
    },
    {
      id: 'PS',
      country: 'PALESTINIAN TERRITORY',
      reg: null
    },
    {
      id: 'RW',
      country: 'RWANDA',
      reg: null
    },
    {
      id: 'SU',
      country: 'UNION OF SOVIET SOCIALIST REPUBLICS',
      reg: null
    },
    {
      id: 'PF',
      country: 'FRENCH POLYNESIA',
      reg: /^987\d{2}$/
    },
    {
      id: 'JO',
      country: 'JORDAN',
      reg: /^\d{5}$/
    },
    {
      id: 'KZ',
      country: 'KAZAKHSTAN',
      reg: /^\d{6}$/
    },
    {
      id: 'Ke',
      country: 'KENYA',
      reg: /^\d{5}$/
    },
    {
      id: 'KG',
      country: 'KYRGYZSTAN',
      reg: /^\d{6}$/
    },
    {
      id: 'SR',
      country: 'SURINAME',
      reg: null
    },
    {
      id: 'LB',
      country: 'LEBANON',
      reg: /^\d{4}\s{0,1}\d{4}$/
    },
    {
      id: 'LS',
      country: 'LESOTHO',
      reg: /^\d{3}$/
    },
    {
      id: 'LY',
      country: 'LIBYAN ARAB JAMAHIRIYA',
      reg: /^\d{5}$/
    },
    {
      id: 'LI',
      country: 'LIECHTENSTEIN',
      reg: /^\d{4}$/
    },
    {
      id: 'MK',
      country: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF',
      reg: /^\d{4}$/
    },
    {
      id: 'MW',
      country: 'MALAWI',
      reg: null
    },
    {
      id: 'ML',
      country: 'MALI',
      reg: null
    },
    {
      id: 'MR',
      country: 'MAURITANIA',
      reg: null
    },
    {
      id: 'MU',
      country: 'MAURITIUS',
      reg: null
    },
    {
      id: 'MD',
      country: 'MOLDOVA, REPUBLIC OF',
      reg: /^[Mm][Dd][- ]{0,1}\d{4}$/
    },
    {
      id: 'MS',
      country: 'MONTSERRAT',
      reg: /^[Mm][Ss][Rr]\s{0,1}\d{4}$/
    },
    {
      id: 'MA',
      country: 'MOROCCO',
      reg: /^\d{5}$/
    },
    {
      id: 'MM',
      country: 'MYANMAR (FORMERLY BURMA)',
      reg: /^\d{5}$/
    },
    {
      id: 'NA',
      country: 'NAMIBIA',
      reg: /^\d{5}$/
    },
    {
      id: 'NI',
      country: 'NICARAGUA',
      reg: /^\d{5}$/
    },
    {
      id: 'NU',
      country: 'NIGER',
      reg: /^\d{4}$/
    },
    {
      id: 'NO',
      country: 'NORWAY',
      reg: /^\d{4}$/
    },
    {
      id: 'OM',
      country: 'OMAN',
      reg: /^\d{3}$/
    },
    {
      id: 'PA',
      country: 'PANAMA',
      reg: /^\d{6}$/
    },
    {
      id: 'PG',
      country: 'PAPUA NEW GUINEA',
      reg: /^\d{3}$/
    },
    {
      id: 'QA',
      country: 'QATAR',
      reg: null
    },
    {
      id: 'RO',
      country: 'ROMANIA',
      reg: /^\d{6}$/
    },
    {
      id: 'KN',
      country: 'SAINT KITTS (CHRISTOPHER) AND NEVIS',
      reg: null
    },
    {
      id: 'LC',
      country: 'SAINT LUCIA',
      reg: null
    },
    {
      id: 'SA',
      country: 'SAUDI ARABIA',
      reg: /^\d{5}(-{1}\d{4})?$/
    },
    {
      id: 'SN',
      country: 'SENEGAL',
      reg: /^\d{5}$/
    },
    {
      id: 'SL',
      country: 'SIERRA LEONE',
      reg: null
    },
    {
      id: 'SB',
      country: 'SOLOMON ISLANDS',
      reg: null
    },
    {
      id: 'SO',
      country: 'SOMALIA',
      reg: null
    },
    {
      id: 'SD',
      country: 'SUDAN',
      reg: /^\d{5}$/
    },
    {
      id: 'SZ',
      country: 'SWAZILAND',
      reg: /^[A-Za-z]\d{3}$/
    },
    {
      id: 'SJ',
      country: 'SVALBARD AND JAN MAYEN ISLANDS',
      reg: /^\d{4}$/
    },
    {
      id: 'TJ',
      country: 'TOGO',
      reg: null
    },
    {
      id: 'TK',
      country: 'TOKELAU',
      reg: null
    },
    {
      id: 'TD',
      country: 'CHAD',
      reg: /^\d{5}$/
    },
    {
      id: 'KM',
      country: 'COMOROS',
      reg: null
    },
    {
      id: 'TP',
      country: 'EAST TIMOR',
      reg: null
    },
    {
      id: 'WS',
      country: 'SAMOA',
      reg: null
    },
    {
      id: 'YK',
      country: 'KOSOVO',
      reg: null
    },
    {
      id: 'FK',
      country: 'FALKLAND ISLANDS (MALVINAS)',
      reg: /^[Ff][Ii][Qq]{2}\s{0,1}[1][Zz]{2}$/
    },
    {
      id: 'GT',
      country: 'GUATEMALA',
      reg: /^\d{5}$/
    },
    {
      id: 'MZ',
      country: 'MOZAMBIQUE',
      reg: /^\d{4}$/
    },
    {
      id: 'SC',
      country: 'SEYCHELLES',
      reg: null
    },
    {
      id: 'LV',
      country: 'LATVIA',
      reg: /^[Ll][Vv][- ]{0,1}\d{4}$/
    },
    {
      id: 'SH',
      country: 'ST HELENA',
      reg: /^[Tt][Dd][Cc][Uu]\s{0,1}[1][Zz]{2}$/
    },
    {
      id: 'ST',
      country: 'SAO TOME AND PRINCIPE',
      reg: null
    },
    {
      id: 'UZ',
      country: 'UZBEKISTAN',
      reg: /^\d{3} \d{3}$/
    },
    {
      id: 'WF',
      country: 'WALLIS AND FUTUNA ISLANDS',
      reg: /^986\d{2}$/
    },
    {
      id: 'YE',
      country: 'YEMEN (UNIFIED NORTH AND SOUTH)',
      reg: null
    },
    {
      id: 'ZM',
      country: 'ZAMBIA',
      reg: /^\d{5}$/
    },
    {
      id: 'ZW',
      country: 'ZIMBABWE',
      reg: null
    },
    {
      id: 'AR',
      country: 'ARGENTINA',
      reg: /^\d{4}|[A-Za-z]\d{4}[a-zA-Z]{3}$/
    },
    {
      id: 'AZ',
      country: 'AZERBAIJAN',
      reg: /^[Aa][Zz]\d{4}$/
    },
    {
      id: 'BB',
      country: 'BARBADOS',
      reg: /^[Aa][Zz]\d{5}$/
    },
    {
      id: 'BM',
      country: 'BERMUDA',
      reg: /^[A-Za-z]{2}\s([A-Za-z]{2}|\d{2})$/
    },
    {
      id: 'BA',
      country: 'BOSNIA & HERZEGOWINA',
      reg: /^\d{5}$/
    },
    {
      id: 'KY',
      country: 'CAYMAN ISLANDS',
      reg: /^[Kk][Yy]\d[-\s]{0,1}\d{4}$/
    },
    {
      id: 'CG',
      country: 'CONGO',
      reg: null
    },
    {
      id: 'CR',
      country: 'COSTA RICA',
      reg: /^\d{4,5}$/
    },
    {
      id: 'CZ',
      country: 'CZECH REPUBLIC',
      reg: /^\d{5}$/
    },
    {
      id: 'DO',
      country: 'DOMINICAN REPUBLIC',
      reg: /^\d{5}$/
    },
    {
      id: 'TL',
      country: 'TIMOR-LESTE',
      reg: null
    },
    {
      id: 'ET',
      country: 'ETHIOPIA',
      reg: /^\d{4}$/
    },
    {
      id: 'GN',
      country: 'GAMBIA',
      reg: null
    },
    {
      id: 'GD',
      country: 'GRENADA',
      reg: null
    },
    {
      id: 'IN',
      country: 'INDIA',
      reg: /^\d{6}$/
    },
    {
      id: 'KP',
      country: 'KOREA, DEMOCRATIC PEOPLE\'S REPUBLIC OF (NORTH KOREA)',
      reg: null
    },
    {
      id: 'TZ',
      country: 'TANZANIA, UNITED REPUBLIC OF',
      reg: null
    },
    {
      id: 'TO',
      country: 'TONGA',
      reg: null
    },
    {
      id: 'LR',
      country: 'LIBERIA',
      reg: /^\d{4}$/
    },
    {
      id: 'LT',
      country: 'LITHUANIA',
      reg: /^[Ll][Tt][- ]{0,1}\d{5}$/
    },
    {
      id: 'NC',
      country: 'NEW CALEDONIA',
      reg: /^988\d{2}$/
    },
    {
      id: 'NF',
      country: 'NORFOLK ISLAND',
      reg: /^\d{4}$/
    },
    {
      id: 'PE',
      country: 'PERU',
      reg: /^\d{5}$/
    },
    {
      id: 'SK',
      country: 'SLOVAKIA (SLOVAK REPUBLIC)',
      reg: /^\d{5}\s\(\d{3}\s\d{2}\)$/
    },
    {
      id: 'TT',
      country: 'TRINIDAD AND TOBAGO',
      reg: /^\d{6}$/
    },
    {
      id: 'JP',
      country: 'JAPAN',
      reg: /^\d{7}$/
    },
  ]
